import { useContext } from 'react';
import { isApptNotificationChannel } from '@components/notifications/utils';
import { useTranslate } from 'nucleus-text';
import useTimezone from '@hooks/useTimezone';
import { getApptNotificationWithLinkedContent } from '@components/appointments/utilities/getApptNotificationWithLinkedContent';
import { NotificationsContext } from '../context/NotificationsContext';

const getUpdatedNotifications = (notifications, translate, date) => {
  return notifications
    .filter(
      notification =>
        !isApptNotificationChannel(notification.channelName) ||
        !notification.isRead
    )
    .map(notification => {
      if (isApptNotificationChannel(notification.channelName)) {
        return getApptNotificationWithLinkedContent(
          notification,
          translate,
          date
        );
      }
      return notification;
    });
};
/**
 * a hook that wraps notifications context, and exposes methods and state which is to
 * be used by other components.
 */
const useNotifications = () => {
  const {
    state,
    addNotifications,
    markAllNotificationsAsRead,
    markAndPublishNotificationsAsRead,
    dismissReminders,
    displayReminders,
    loading,
    setApolloClient,
    revokePubNubAuthKey
  } = useContext(NotificationsContext);
  const { translate } = useTranslate();
  const { date } = useTimezone();

  return {
    addNotifications,
    markAllNotificationsAsRead,
    markAndPublishNotificationsAsRead,
    dismissReminders,
    displayReminders,
    notifications: getUpdatedNotifications(
      state.notifications,
      translate,
      date
    ),
    reminders: state.reminders,
    loading,
    setApolloClient,
    revokePubNubAuthKey
  };
};

export default useNotifications;
